import styled from "styled-components";
import { COLORS } from "../../../constants";

export const Letter = styled.h3`
  color: ${COLORS.PRIMARY};
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;